import { palette, v1Theme } from '../styles/tokens'

export default {
  created() {
    Object.assign(this.$vuetify.theme, palette)
    document.documentElement.classList.add('v2-active')
  },
  beforeDestroy() {
    Object.assign(this.$vuetify.theme, v1Theme)
    document.documentElement.classList.remove('v2-active')
  },
}
